import useSWR from 'swr';

import { SWR_GLOBAL_CONFIG } from '~/api/_constant';
import { OpenAPISchemas } from '~/api/_openapi';
import { request } from '~/api/_utils/request';

const getPath = (uid?: string | number) => `/v2/organizations/${uid}/locations`;

type Response = {
  organization_locations?: OpenAPISchemas.V1CorporatesLocationsIndex200CorporateLocationsItem[];
  post_locations?: OpenAPISchemas.V1CorporatesLocationsIndex200PostLocationsItem[];
};

export async function apiGetV2OrganizationByIdLocations(uid?: string | number) {
  if (!uid) return {};
  const response = await request.GET<Response>(getPath(uid));
  return response;
}

export function useSWRV2OrganizationByIdLocations(uid?: string | number) {
  const swr = useSWR(getPath(uid), () => apiGetV2OrganizationByIdLocations(uid), SWR_GLOBAL_CONFIG);
  const data = swr.data;
  return {
    ...swr,
    orgLocations: data?.organization_locations ?? undefined,
    postLocations: data?.post_locations ?? undefined,
  };
}
